import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-320px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = ["id", "data-kt-scroll-dependencies", "data-kt-scroll-wrappers"]
const _hoisted_10 = { class: "modal-footer flex-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_15 = { key: 1 }

import { ref } from "vue";
import { hideModal, showModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelConfirm',
  props: {
  title: { type: String, required: true },
  submited: { type: Boolean, required: true },
  okTitle: String,
  submitTitle: String,
  cancelTitle: String,
  cancel: { type: Function, required: false },
  ok: { type: Function, required: true },
  elId: { type: String, required: true },
},
  setup(__props, { expose: __expose }) {

const props = __props;


const modelRef = ref(null);

const hide = () => {
  hideModal(modelRef.value);
};

const show = () => {
  console.log("show model");
  showModal(modelRef.value);
};

const ok = () => {
  props.ok();
};

const cancel = () => {
  if (props.cancel) {
    props.cancel();
  }
};
__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: props.elId,
    ref_key: "modelRef",
    ref: modelRef,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "modal-header",
          id: props.elId + 'header'
        }, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.title) + " " + _toDisplayString("ref_" + props.elId), 1),
          _createElementVNode("div", {
            id: props.elId + 'close',
            "data-bs-dismiss": "modal",
            class: "btn btn-icon btn-sm btn-active-icon-primary"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ], 8, _hoisted_4),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "scroll-y me-n7 pe-7",
            id: props.elId + 'scroll',
            "data-kt-scroll": "true",
            "data-kt-scroll-activate": "{default: false, lg: true}",
            "data-kt-scroll-max-height": "auto",
            "data-kt-scroll-dependencies": '#' + props.elId + '_header',
            "data-kt-scroll-wrappers": '#' + props.elId + '_scroll',
            "data-kt-scroll-offset": "300px"
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            id: "model_form_close",
            class: "btn btn-light me-3",
            "data-bs-dismiss": "modal",
            onClick: _withModifiers(cancel, ["prevent"])
          }, _toDisplayString(props.cancelTitle ? props.cancelTitle : _ctx.$t("action.discard")), 9, _hoisted_11),
          _createElementVNode("button", {
            id: "model_form_submit",
            class: "btn btn-primary",
            onClick: ok,
            disabled: props.submited
          }, [
            (__props.submited)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createTextVNode(_toDisplayString(props.submitTitle ? props.submitTitle : _ctx.$t("action.saving")) + " ", 1),
                  _hoisted_14
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.okTitle ? props.okTitle : _ctx.$t("action.save")), 1))
          ], 8, _hoisted_12)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})